require("!!/Users/mattijsnaus/Documents/chillyorange/Builder/blockery/node_modules/script-loader/addScript.js")(require("!!/Users/mattijsnaus/Documents/chillyorange/Builder/blockery/node_modules/raw-loader/index.js!/Users/mattijsnaus/Documents/chillyorange/Builder/blockery/assets/Yummy/js/vendors/metismenu/metisMenu.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./assets/Yummy/js/vendors/metismenu/metisMenu.min.js
// module id = 84
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 12 13 14 15 16 17 18 19 20 21